import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CpuChip02 = function CpuChip02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 2v3m6-3v3M9 19v3m6-3v3m4-13h3m-3 5h3M2 9h3m-3 5h3m4.8 5h4.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 16.7202 19 15.8802 19 14.2V9.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C16.7202 5 15.8802 5 14.2 5H9.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C5 7.2798 5 8.1198 5 9.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C7.2798 19 8.1198 19 9.8 19"
    })
  }));
};
export default CpuChip02;